/**
 * Ícones por defeito para grupos e características do catálogo.
 *
 * O ADMIN pode definir o ícone na admin; quando não define, escolhe-se aqui
 * pela descrição base em inglês. Usa sobretudo Material Design Icons (já
 * carregada no projeto e com o conjunto mais completo de casa/domótica) e
 * Remix para o resto. Sem correspondência fica sem ícone.
 */
const GROUP_ICONS: { match: RegExp; icon: string }[] = [
  { match: /division|interior|room/i, icon: 'mdi mdi-floor-plan' },
  { match: /surround|view|nearby|proximit/i, icon: 'mdi mdi-map-marker-radius-outline' },
  { match: /securit/i, icon: 'mdi mdi-shield-home-outline' },
  { match: /equip|applianc|feature/i, icon: 'mdi mdi-power-plug-outline' },
  { match: /service/i, icon: 'mdi mdi-room-service-outline' },
  { match: /infra|leisure|condo/i, icon: 'mdi mdi-office-building-outline' },
  { match: /purpose/i, icon: 'mdi mdi-flag-outline' },
  { match: /area|measure/i, icon: 'mdi mdi-ruler-square' },
  { match: /extra/i, icon: 'mdi mdi-star-four-points-outline' },
  { match: /ground|land|terrain/i, icon: 'mdi mdi-terrain' },
  { match: /solar|orientation/i, icon: 'mdi mdi-weather-sunny' },
  { match: /access/i, icon: 'mdi mdi-wheelchair-accessibility' },
  { match: /sustain|energy|eco/i, icon: 'mdi mdi-leaf' },
  { match: /tech|automation|smart/i, icon: 'mdi mdi-home-automation' },
  { match: /finish/i, icon: 'mdi mdi-format-paint' },
  { match: /pet/i, icon: 'mdi mdi-paw' },
  { match: /document|legal/i, icon: 'mdi mdi-file-document-outline' },
];

/** Ordem importa: a primeira correspondência ganha, as mais específicas vêm primeiro. */
const CHARACTERISTIC_ICONS: { match: RegExp; icon: string }[] = [
  // --- água e lazer
  { match: /jacuzzi|hydromassage|hot tub/i, icon: 'mdi mdi-hot-tub' },
  { match: /sauna|turkish bath|spa\b/i, icon: 'mdi mdi-spa-outline' },
  { match: /\bpool|swimming/i, icon: 'mdi mdi-pool' },
  { match: /gym|sports|dumbbell/i, icon: 'mdi mdi-dumbbell' },
  { match: /tennis/i, icon: 'mdi mdi-tennis' },
  { match: /golf/i, icon: 'mdi mdi-golf' },
  { match: /playground|children|game room|games room|cinema/i, icon: 'mdi mdi-gamepad-variant-outline' },
  { match: /party|canteen|bar\b|salon|lounge/i, icon: 'mdi mdi-glass-cocktail' },
  // --- estacionamento e acessos
  { match: /truck|loading|unloading|dock|maneuver/i, icon: 'mdi mdi-truck-outline' },
  { match: /garage|parking|carport/i, icon: 'mdi mdi-garage-variant' },
  { match: /elevator|lift/i, icon: 'mdi mdi-elevator-passenger-outline' },
  { match: /disabled|accessib|ramp|wheelchair/i, icon: 'mdi mdi-wheelchair-accessibility' },
  { match: /\bgate|portão/i, icon: 'mdi mdi-gate' },
  { match: /ramp|stairs|floors|floor\b/i, icon: 'mdi mdi-stairs' },
  // --- climatização e energia
  { match: /air cond|heat pump/i, icon: 'mdi mdi-air-conditioner' },
  { match: /fireplace|heat recover|stove\b/i, icon: 'mdi mdi-fireplace' },
  { match: /central heating|underfloor|radiant|radiator|towel rail/i, icon: 'mdi mdi-radiator' },
  { match: /water heater|heater|boiler|solar hot water/i, icon: 'mdi mdi-water-boiler' },
  { match: /solar|photovolt|microgeneration|renewable/i, icon: 'mdi mdi-solar-panel' },
  { match: /generator|three-phase|electric(ity)?\b|light\b/i, icon: 'mdi mdi-lightning-bolt-outline' },
  { match: /gas\b|piped gas|natural gas|bottle/i, icon: 'mdi mdi-gas-cylinder' },
  { match: /piped water|water well|well\b|cistern|hydropneumatic|water\b/i, icon: 'mdi mdi-water-pump' },
  { match: /sewage|sanitation|drain/i, icon: 'mdi mdi-pipe' },
  { match: /thermal insulation|soundproof|insulation/i, icon: 'mdi mdi-home-thermometer-outline' },
  // --- cozinha e eletrodomésticos
  { match: /dishwasher/i, icon: 'mdi mdi-dishwasher' },
  { match: /washing machine/i, icon: 'mdi mdi-washing-machine' },
  { match: /dryer/i, icon: 'mdi mdi-tumble-dryer' },
  { match: /fridge|refrigerator|combined/i, icon: 'mdi mdi-fridge-outline' },
  { match: /microwave/i, icon: 'mdi mdi-microwave' },
  { match: /oven|hob|plate|cooker/i, icon: 'mdi mdi-stove' },
  { match: /exhaust|hood/i, icon: 'mdi mdi-fan' },
  { match: /kitchen|larder|pantry|utensil|canteen/i, icon: 'mdi mdi-silverware-fork-knife' },
  { match: /iron|sheets|towels|linen|laundry/i, icon: 'mdi mdi-iron-outline' },
  { match: /vac+um|aspiration/i, icon: 'mdi mdi-robot-vacuum' },
  { match: /barbe?cue|bbq|grill/i, icon: 'mdi mdi-grill' },
  { match: /bicycle|bike/i, icon: 'mdi mdi-bike' },
  { match: /awning|canopy/i, icon: 'mdi mdi-umbrella-outline' },
  { match: /soil/i, icon: 'mdi mdi-shovel' },
  { match: /kettle|coffee/i, icon: 'mdi mdi-kettle-outline' },
  // --- divisões e mobiliário
  { match: /bathroom|wc\b|toilet|service wc|shared wc/i, icon: 'mdi mdi-toilet' },
  { match: /bathtub|poliban|shower/i, icon: 'mdi mdi-bathtub-outline' },
  { match: /suite|bedroom|guest room|interior room|total room|inner room/i, icon: 'mdi mdi-bed-outline' },
  { match: /beds?\b|sofa bed/i, icon: 'mdi mdi-bed-king-outline' },
  { match: /closet|wardrobe|hanger/i, icon: 'mdi mdi-wardrobe-outline' },
  { match: /living room|room \(s\)|dining|openspace|open space|hall/i, icon: 'mdi mdi-sofa-outline' },
  { match: /office|study|meeting|conference|coworking|administrative|library/i, icon: 'mdi mdi-desk' },
  { match: /balcon|terrace|porch|solarium|sun room|veranda|marquise/i, icon: 'mdi mdi-balcony' },
  { match: /attic|basement|storeroom|storage|cellar|wine|barn|warehouse|attach|annex/i, icon: 'mdi mdi-warehouse' },
  { match: /locker|cloakroom/i, icon: 'mdi mdi-locker-multiple' },
  { match: /furnish|furniture/i, icon: 'mdi mdi-sofa-single-outline' },
  { match: /kitchenette/i, icon: 'mdi mdi-countertop-outline' },
  // --- segurança e domótica
  { match: /alarm|intrusion/i, icon: 'mdi mdi-alarm-light-outline' },
  { match: /video|cctv|surveillance|camera|closed circuit/i, icon: 'mdi mdi-cctv' },
  { match: /smoke|fire detect|fire door/i, icon: 'mdi mdi-smoke-detector-outline' },
  { match: /flood detect|gas detect/i, icon: 'mdi mdi-alert-decagram-outline' },
  { match: /armored|high security door|safe box|fence|wall\b|seal/i, icon: 'mdi mdi-shield-home-outline' },
  { match: /24 hour|security|ordinance|porter|concierge/i, icon: 'mdi mdi-account-tie-outline' },
  { match: /intercom|door|entrance/i, icon: 'mdi mdi-door-closed' },
  { match: /automation|domot|smart|ambient music|phone central/i, icon: 'mdi mdi-home-automation' },
  { match: /internet|wi-?fi|cable|antenna|telephone|phone|tv\b/i, icon: 'mdi mdi-wifi' },
  { match: /blind|blackout|curtain|window|glass|mirror|tinted/i, icon: 'mdi mdi-blinds' },
  { match: /false ceiling|raised floor|partition/i, icon: 'mdi mdi-view-grid-outline' },
  // --- exterior e envolvente
  { match: /garden|green|lawn|fruit|vineyard|field|tree/i, icon: 'mdi mdi-tree-outline' },
  { match: /beach|sea\b|ocean/i, icon: 'mdi mdi-beach' },
  { match: /river|lake|dam\b|water line|course/i, icon: 'mdi mdi-waves' },
  { match: /mountain|countryside|slope|terrain|land\b|ground/i, icon: 'mdi mdi-terrain' },
  { match: /\bview\b/i, icon: 'mdi mdi-eye-outline' },
  { match: /gated|condominium|horizontal property/i, icon: 'mdi mdi-home-group' },
  { match: /anchor|marina|port\b/i, icon: 'mdi mdi-ferry' },
  { match: /airport/i, icon: 'mdi mdi-airplane' },
  { match: /train|railway/i, icon: 'mdi mdi-train' },
  { match: /subway|metro/i, icon: 'mdi mdi-subway-variant' },
  { match: /bus\b|transport|taxi/i, icon: 'mdi mdi-bus' },
  { match: /highway|road|asphalt/i, icon: 'mdi mdi-road-variant' },
  { match: /hospital|pharmac/i, icon: 'mdi mdi-hospital-box-outline' },
  { match: /school|universit/i, icon: 'mdi mdi-school-outline' },
  { match: /bank/i, icon: 'mdi mdi-bank-outline' },
  { match: /fuel|petrol/i, icon: 'mdi mdi-gas-station-outline' },
  { match: /police|firefight/i, icon: 'mdi mdi-police-badge-outline' },
  { match: /shop|mall|market|commercial|downtown|city|history/i, icon: 'mdi mdi-store-outline' },
  { match: /street lighting|public place/i, icon: 'mdi mdi-lightbulb-on-outline' },
  // --- animais, pessoas, alojamento
  { match: /pet|animal|dog/i, icon: 'mdi mdi-paw' },
  { match: /smok/i, icon: 'mdi mdi-smoking-off' },
  { match: /people|adult|children|extra|shared house|shared room/i, icon: 'mdi mdi-account-group-outline' },
  { match: /cleaning|maintenance service|garden service|kitchen service|service\b/i, icon: 'mdi mdi-room-service-outline' },
  { match: /price|cost|rental|lease|period/i, icon: 'mdi mdi-cash-multiple' },
  { match: /licen|document|conservation|building\b|construction/i, icon: 'mdi mdi-file-document-outline' },
  // --- áreas e medidas
  { match: /area|front|length|width|depth|right foot|surface/i, icon: 'mdi mdi-ruler-square' },
  { match: /orientation|exposure|solar/i, icon: 'mdi mdi-compass-outline' },
  { match: /industrial|logistic/i, icon: 'mdi mdi-factory' },
  { match: /residential|particular/i, icon: 'mdi mdi-home-outline' },
];

function pick(list: { match: RegExp; icon: string }[], text: string): string | null {
  const value = `${text ?? ''}`;
  if (!value) return null;
  const hit = list.find((entry) => entry.match.test(value));
  return hit ? hit.icon : null;
}

export function groupIconFor(icon: string | null | undefined, baseDescription: string): string | null {
  return icon || pick(GROUP_ICONS, baseDescription) || 'mdi mdi-tag-outline';
}

export function characteristicIconFor(icon: string | null | undefined, baseDescription: string): string | null {
  return icon || pick(CHARACTERISTIC_ICONS, baseDescription);
}
